// NEON PALM drop-in sections — shared behaviors
(function () {
  if (window.__npInit) return;
  window.__npInit = true;

  // Reveal-on-scroll
  function bindReveal() {
    var els = document.querySelectorAll('.np-reveal:not(.np-bound)');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('np-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) {
      el.classList.add('np-bound');
      io.observe(el);
    });
  }

  // FAQ accordion: only one open at a time, per FAQ section
  function bindFaq() {
    document.querySelectorAll('.np-faq:not([data-np-bound])').forEach(function (faq) {
      faq.setAttribute('data-np-bound', '1');
      var qs = faq.querySelectorAll('details.np-q');
      qs.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) qs.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  function init() { bindReveal(); bindFaq(); }
  init();

  // Re-bind when Shopify theme editor adds/changes a section
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
})();
